"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostMessage = void 0;
var _PostMessage;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// eslint-disable-next-line import/prefer-default-export
class PostMessage {}
exports.PostMessage = PostMessage;
_PostMessage = PostMessage;
_defineProperty(PostMessage, "registerTargetOrigins", targetOrigins => {
  sessionStorage.setItem('targetOrigins', JSON.stringify(targetOrigins));
});
_defineProperty(PostMessage, "getRegisteredTargetOrigins", () => {
  const targetOriginsStr = sessionStorage.getItem('targetOrigins');
  if (targetOriginsStr) {
    return JSON.parse(targetOriginsStr);
  }
  return [];
});
_defineProperty(PostMessage, "postMessageToRegisteredTargetOrigins", data => {
  try {
    const target = window.parent || window;
    const targetOriginsStr = sessionStorage.getItem('targetOrigins');
    if (targetOriginsStr) {
      const targetOrigins = JSON.parse(targetOriginsStr);
      targetOrigins.forEach(targetOrigin => {
        target.postMessage(data, targetOrigin);
      });
    }
    target.postMessage(data, window.location.origin);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
});
// Send standard messages { src, status, message, additionalData }
_defineProperty(PostMessage, "postMessage", (src, status, message, additionalData) => {
  const data = {
    src,
    status,
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageCore", (status, message, additionalData) => {
  const data = {
    src: 'core',
    status,
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageCoreSuccess", (message, additionalData) => {
  const data = {
    src: 'core',
    status: 'SUCCESS',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageCoreError", (message, additionalData) => {
  const data = {
    src: 'core',
    status: 'ERROR',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageCoreClose", (message, additionalData) => {
  const data = {
    src: 'core',
    status: 'CLOSE',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageCoreEvent", (message, additionalData) => {
  const data = {
    src: 'core',
    status: 'EVENT',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageSuccess", (src, message, additionalData) => {
  const data = {
    src,
    status: 'SUCCESS',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageError", (src, message, additionalData) => {
  const data = {
    src,
    status: 'ERROR',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageClose", (src, message, additionalData) => {
  const data = {
    src,
    status: 'CLOSE',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "postMessageEvent", (src, message, additionalData) => {
  const data = {
    src,
    status: 'EVENT',
    message,
    additionalData
  };
  _PostMessage.postMessageToRegisteredTargetOrigins(data);
});
_defineProperty(PostMessage, "listenCore", (listener, filters) => {
  window.addEventListener('message', event => {
    var _event$data;
    if (event.origin !== window.location.origin) {
      return;
    }
    if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.src) === 'core') {
      if (filters && filters.length > 0) {
        const match = filters.some(filter => filter === event.data.message);
        if (match) {
          listener(event.data);
        }
      } else {
        listener(event.data);
      }
    }
  });
});
//# sourceMappingURL=PostMessage.js.map